import { render } from "./ListeTypeFretPaiePage.vue?vue&type=template&id=d13a6cc2&ts=true"
import script from "./ListeTypeFretPaiePage.vue?vue&type=script&lang=ts"
export * from "./ListeTypeFretPaiePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__